!function() {
    var StickyFeature = function(element) {
        this.element = element;
        this.contentList = this.element.getElementsByClassName("js-sticky-feature__content-list");
        this.mediaList = this.element.getElementsByClassName("js-sticky-feature__media-list");

        if (this.contentList.length < 1 || this.mediaList.length < 1) return;

        this.contentItems = this.contentList[0].getElementsByClassName("js-sticky-feature__content-item");
        this.mediaItems = this.mediaList[0].getElementsByClassName("js-sticky-feature__media-item");
        this.titleItems = this.contentList[0].getElementsByClassName("js-sticky-feature__content");
        this.activeClass = "sticky-feature-current-item";
        this.bindScroll = false;
        this.isScrolling = false;

        function initializeScrollHandler(stickyFeatureInstance) {
            new IntersectionObserver(function(entries) {
                if (entries[0].isIntersecting) {
                    if (!stickyFeatureInstance.bindScroll) {
                        bindScroll(stickyFeatureInstance);
                    }
                } else {
                    if (stickyFeatureInstance.bindScroll) {
                        unbindScroll(stickyFeatureInstance);
                    }
                }
            }.bind(stickyFeatureInstance)).observe(stickyFeatureInstance.contentList[0]);

            // Check for the 'js-sticky-feature--clickable' class before enabling click functionality
            if (stickyFeatureInstance.element.classList.contains("js-sticky-feature--clickable")) {
                for (var i = 0; i < stickyFeatureInstance.titleItems.length; i++) {
                    (function(index) {
                        stickyFeatureInstance.titleItems[index].addEventListener("click", function() {
                            scrollToContent(stickyFeatureInstance, index);
                        });
                    })(i);
                }
            }
        }

        function bindScroll(stickyFeatureInstance) {
            stickyFeatureInstance.bindScroll = function() {
                if (!stickyFeatureInstance.isScrolling) {
                    stickyFeatureInstance.isScrolling = true;
                    window.requestAnimationFrame(function() {
                        updateActiveItem(stickyFeatureInstance);
                        stickyFeatureInstance.isScrolling = false;
                    });
                }
            };
            window.addEventListener("scroll", stickyFeatureInstance.bindScroll);
        }

        function unbindScroll(stickyFeatureInstance) {
            if (stickyFeatureInstance.bindScroll) {
                window.removeEventListener("scroll", stickyFeatureInstance.bindScroll);
                stickyFeatureInstance.bindScroll = false;
            }
        }

        function updateActiveItem(stickyFeatureInstance) {
            resetActiveItems(stickyFeatureInstance);
            var visibleItems = [];
            for (var i = 0; i < stickyFeatureInstance.contentItems.length; i++) {
                if (stickyFeatureInstance.contentItems[i].getBoundingClientRect().top <= window.innerHeight / 2) {
                    visibleItems.push(i);
                }
            }

            var activeIndex = visibleItems.length > 0 ? visibleItems[visibleItems.length - 1] : 0;
            stickyFeatureInstance.contentItems[activeIndex].classList.add(stickyFeatureInstance.activeClass);
            stickyFeatureInstance.mediaItems[activeIndex].classList.add(stickyFeatureInstance.activeClass);
        }

        function resetActiveItems(stickyFeatureInstance) {
            var activeElements = stickyFeatureInstance.element.getElementsByClassName(stickyFeatureInstance.activeClass);
            while (activeElements[0]) {
                activeElements[0].classList.remove(stickyFeatureInstance.activeClass);
            }
        }

        function scrollToContent(stickyFeatureInstance, index) {
            if (stickyFeatureInstance.mediaList[0].offsetWidth < 1) return;

            window.scrollBy({
                top: stickyFeatureInstance.titleItems[index].getBoundingClientRect().top - window.innerHeight / 2 + 10,
                behavior: "smooth"
            });
        }

        initializeScrollHandler(this);
    };

    window.StickyFeature = StickyFeature;

    var stickyFeatureElements = document.getElementsByClassName("js-sticky-feature");
    if (stickyFeatureElements.length > 0) {
        for (var i = 0; i < stickyFeatureElements.length; i++) {
            new StickyFeature(stickyFeatureElements[i]);
        }
    }
}();